/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.DashboardPageBlockCustomTableColumn = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The DashboardPageBlockCustomTableColumn model module.
   * @module model/DashboardPageBlockCustomTableColumn
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>DashboardPageBlockCustomTableColumn</code>.
   * @alias module:model/DashboardPageBlockCustomTableColumn
   * @class
   */
  var exports = function() {
    var _this = this;
















  };

  /**
   * Constructs a <code>DashboardPageBlockCustomTableColumn</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DashboardPageBlockCustomTableColumn} obj Optional instance to populate.
   * @return {module:model/DashboardPageBlockCustomTableColumn} The populated <code>DashboardPageBlockCustomTableColumn</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('SourceColumnName')) {
        obj['SourceColumnName'] = ApiClient.convertToType(data['SourceColumnName'], 'String');
      }
      if (data.hasOwnProperty('HeaderColumnName')) {
        obj['HeaderColumnName'] = ApiClient.convertToType(data['HeaderColumnName'], 'String');
      }
      if (data.hasOwnProperty('DecimalPlaces')) {
        obj['DecimalPlaces'] = ApiClient.convertToType(data['DecimalPlaces'], 'Integer');
      }
      if (data.hasOwnProperty('ValueSuffix')) {
        obj['ValueSuffix'] = ApiClient.convertToType(data['ValueSuffix'], 'String');
      }
      if (data.hasOwnProperty('AggregationFunction')) {
        obj['AggregationFunction'] = ApiClient.convertToType(data['AggregationFunction'], 'String');
      }
      if (data.hasOwnProperty('SortOrder')) {
        obj['SortOrder'] = ApiClient.convertToType(data['SortOrder'], 'String');
      }
      if (data.hasOwnProperty('UseHeatScale')) {
        obj['UseHeatScale'] = ApiClient.convertToType(data['UseHeatScale'], 'Boolean');
      }
      if (data.hasOwnProperty('Sort')) {
        obj['Sort'] = ApiClient.convertToType(data['Sort'], 'Integer');
      }
      if (data.hasOwnProperty('Filterable')) {
        obj['Filterable'] = ApiClient.convertToType(data['Filterable'], 'Boolean');
      }
      if (data.hasOwnProperty('TotalRowDividendColumnID')) {
        obj['TotalRowDividendColumnID'] = ApiClient.convertToType(data['TotalRowDividendColumnID'], 'Integer');
      }
      if (data.hasOwnProperty('TotalRowDivisorColumnID')) {
        obj['TotalRowDivisorColumnID'] = ApiClient.convertToType(data['TotalRowDivisorColumnID'], 'Integer');
      }
      if (data.hasOwnProperty('DefaultFilterID')) {
        obj['DefaultFilterID'] = ApiClient.convertToType(data['DefaultFilterID'], 'Integer');
      }
      if (data.hasOwnProperty('TextFilter')) {
        obj['TextFilter'] = ApiClient.convertToType(data['TextFilter'], 'String');
      }
      if (data.hasOwnProperty('BlockID')) {
        obj['BlockID'] = ApiClient.convertToType(data['BlockID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} SourceColumnName
   * @default ''
   */
  exports.prototype['SourceColumnName'] = '';
  /**
   * @member {String} HeaderColumnName
   * @default ''
   */
  exports.prototype['HeaderColumnName'] = '';
  /**
   * @member {Integer} DecimalPlaces
   */
  exports.prototype['DecimalPlaces'] = undefined;
  /**
   * @member {String} ValueSuffix
   * @default ''
   */
  exports.prototype['ValueSuffix'] = '';
  /**
   * @member {String} AggregationFunction
   * @default ''
   */
  exports.prototype['AggregationFunction'] = '';
  /**
   * @member {String} SortOrder
   * @default ''
   */
  exports.prototype['SortOrder'] = '';
  /**
   * @member {Boolean} UseHeatScale
   * @default false
   */
  exports.prototype['UseHeatScale'] = false;
  /**
   * @member {Integer} Sort
   * @default 0
   */
  exports.prototype['Sort'] = 0;
  /**
   * @member {Boolean} Filterable
   * @default false
   */
  exports.prototype['Filterable'] = false;
  /**
   * @member {Integer} TotalRowDividendColumnID
   */
  exports.prototype['TotalRowDividendColumnID'] = undefined;
  /**
   * @member {Integer} TotalRowDivisorColumnID
   */
  exports.prototype['TotalRowDivisorColumnID'] = undefined;
  /**
   * @member {Integer} DefaultFilterID
   * @default 0
   */
  exports.prototype['DefaultFilterID'] = 0;
  /**
   * @member {String} TextFilter
   * @default ''
   */
  exports.prototype['TextFilter'] = '';
  /**
   * @member {Integer} BlockID
   * @default 0
   */
  exports.prototype['BlockID'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


